import {
  Alert,
  AuthActions,
  Phone,
  SET_ALERT,
  SET_LOADING,
  SET_PHONE,
  SET_STEP,
  SET_VERIFY_CODE
} from './types';

export interface AuthState {
  isLoading: boolean,
  phone: Phone,
  verifyCode: string,
  alert: Alert | null,
  step: number
}

export const initialState: AuthState = {
  isLoading: false,
  phone: {
    number: '',
    code: '84',
    valid: false
  },
  verifyCode: '',
  alert: null,
  step: 0
};


function reducer(state: AuthState, action: AuthActions): AuthState {
  switch (action.type) {
    case SET_LOADING:
      return {...state, isLoading: action.payload};

    case SET_ALERT:
      return {...state, alert: action.payload};

    case SET_PHONE:
      return {...state, phone: action.payload};

    case SET_VERIFY_CODE:
      return {...state, verifyCode: action.payload};

    case SET_STEP:
      return {...state, step: action.payload};

    default:
      return state
  }
}

export default reducer
